import { useVectorCapitalSimulator } from '../VectorCapitalSimulatorContext';

export default function VcKeyInsightsWidget() {
  const sim = useVectorCapitalSimulator();
  return sim.renderKeyInsights();
}
